import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { formatDate, Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { firstValueFrom, Subscription } from 'rxjs';
import {
  getFormattedDate,
  getFormattedDateTime,
  getFormattedTime,
  getStartEndDateTime,
  getWelfareCheckInterval,
  globalPatrolRouteStatusDict,
  isLargeScreen,
  MAX_SHIFT_DURATION,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { ChangeScheduleComponent } from '../../../../shared/components/change-schedule/change-schedule.component';
import { ClockInOutComponent } from '../../../../shared/components/clock-in-out/clock-in-out.component';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { MediaPreviewComponent } from '../../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { PrompterComponent } from '../../../../shared/components/prompter/prompter.component';
import { ScanCheckpointComponent } from '../../../../shared/components/scan-checkpoint/scan-checkpoint.component';
import { ViewUserDetailComponent } from '../../../../shared/components/view-user-detail/view-user-detail.component';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { gTDB } from '../../../../shared/services/db';
import { DeviceInfoService } from '../../../../shared/services/device-info.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { NativeBgUploadService } from '../../../../shared/services/native-bg-upload.service';
import { OrientationLockService } from '../../../../shared/services/orientationlock.service';
import { SqliteDbService } from '../../../../shared/services/sqlite-db.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { CheckpointService } from '../../checkpoints/checkpoint.service';
import { ClientsService } from '../../clients/clients.service';
import { PagesService } from '../../pages.service';
import { RosterShiftsService } from '../../roster-shifts/roster-shifts.service';
import { AddEditUserComponent } from '../../users/add-edit-user/add-edit-user.component';
import { JobsService } from '../jobs.service';
@Component({
  selector: 'gtapp-patrol-detail',
  templateUrl: './patrol-detail.component.html',
  styleUrl: './patrol-detail.component.scss',
  standalone: false,
})
export class PatrolDetailComponent implements OnInit {
  // @ViewChild(CustomPipe) customPipe: CustomPipe;
  routeId: any;
  checkpointPatrolDetailData: any;

  // change schedule component
  validEndDate: any;

  dialogRef: any;
  hasQrCheckpoint: boolean = false;

  patrolRouteCPList: any = [];
  patrolRouteCpTotalCount: number = 0;
  selectedCheckpoints: any = [];

  patrolCpFilterValue: any;
  cpSiteFilter: any = {};
  patrolCPCursor: string = '';

  siteListData: any = [];
  siteListDataBackup: any = [];
  checkpointSearchTimeoutFn: any;

  selectedAssignee: any = {};
  assigneeList: any = [];

  isAdmin: boolean = false;
  isDispatchUser: boolean = false;
  canScheduleBeUpdated: boolean = false;
  isCurrentORFutureSchedule: boolean = false;
  showWelfareItem: boolean = true;
  hasScheduleStarted: boolean = false;
  schedulerForm: UntypedFormGroup = new UntypedFormGroup({
    end_time: new FormControl(null),
    start_time: new FormControl(null),
    start_day: new FormControl(new Date()),
    end_day: new FormControl(null, Validators.required),
    repeat_times: new UntypedFormControl(null),
    repeat_type: new UntypedFormControl(null, Validators.required),
    repeat_details: new UntypedFormControl([]),
    repeat_interval: new UntypedFormControl(1, [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]),
    position: new UntypedFormControl(null, []),
    week_day: new UntypedFormControl(null, []),
    month_repeat_case: new UntypedFormControl(null, []),
  });

  scheduleDuration: any;
  intervalData: any = [];
  welfareReminderDict: any = {};
  newPatrolName: any;
  selectedInterval: any;
  patrolRouteStatusKey: number = 0;
  patrolRouteStatus: any = globalPatrolRouteStatusDict;

  loggedInUpdatesSet = new Set<string>();
  updateTask: any;
  patrolUpdateLog: any = [];
  patrolUpdateLogBackup: any = [];
  patrolLogUpdates: any = [];
  mobileUpdatesLog: any = [];
  patrolLogTableDetail = [
    {
      header: 'Date / Update By',
      sortKey: 'updated_datetime',
      dateRangeKey: 'updated_datetime',
      datetimeObj: true,
      sortOrder: 'asc',

      nestedValue: (row: any) => {
        return row?.updated_datetime || row?.updated_at;
      },
      suffixNestedValue: (row: any) => {
        return `\n${row?.user_name}`;
      },

      tableColumnStyle: {
        'white-space': 'pre-line',
      },
    },

    {
      header: 'Update',
      name: 'action',
      sortKey: 'action',
      searchKey: 'action',
    },
  ];

  subscriberUserId: any;
  offlineMode: boolean = false;
  newComment: any;
  previousComment: any;

  filterPatrolData: any = { checkpoint: [], company: [], site: [] };
  selectedEvent: any;
  selectedEvenId: string = '';
  otherParams: any = {
    tableRowStyle: (rowData: any) => {
      if (rowData?.is_deleted) {
        return {
          opacity: '0.6',
        };
      }
      return {};
    },
  };
  scanComplete: boolean = false;

  scannedCheckpointCount: number = 0;
  messageChannel = new MessageChannel();
  fetchingDataFromServer: boolean = false;

  missedCheckpoints: any = [];
  scannedCheckpoints: any = {};
  newInfromation: any;
  changeSortOrder: boolean = false;
  largeView = isLargeScreen;
  deviceInfoSubscription: Subscription = new Subscription();
  nativeUploadSubscription: Subscription = new Subscription();
  endDateTime: any;
  startDateTime: any;
  originalDateTimeShift: any = {};

  disableShiftUpdate: boolean = false;
  shiftTimeExceeded: boolean = false;

  validStartDate: any;
  hasJobStarted: boolean = false;

  patrolTime = { startTime: new Date(), endTime: new Date() };

  updateBtnPressed: boolean = false;

  canDeclineJob: boolean = false;
  declineReason: string = '';

  requiresAcceptance: boolean = false;

  scheduleCheck: boolean = true;

  sortCheckpointsWithTimeOut: any;
  bottomSectionFixedHeight: string = '100px';

  itemsNotInServer: any = [];

  errorItemsIdsInQueue = new Set();
  syncInProgress: boolean = false;
  refreshData: boolean = false;

  nfcReaderAvailable: boolean = false;

  userDetailPopoverTemplate = ViewUserDetailComponent;

  patrolJobTypeData: any = {};

  lastAddedCheckpointID: string = '';
  checkpointAddedTimeoutFn: any;

  shiftClockInOutParms = {
    requiresClockInOut: false,
    hasUserClockedIn: false,
    hasUserClockedOut: false,
    cPatrolId: '',
    shiftStartTime: new Date(),
    shiftEndTime: new Date(),
  };

  nfcCheckpointsInPatrol: boolean = false;

  isNativeApp = Capacitor.isNativePlatform();

  cachedListWithTimeOut: any;

  constructor(
    private checkpointService: CheckpointService,
    private spinnerService: LoadingSpinnerService,
    private pageService: PagesService,
    private jobService: JobsService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: ModalDialogueService,
    private appService: AppService,
    private dataCheckService: DataCheckService,
    private rsService: RosterShiftsService,
    private ngZone: NgZone,
    private sanitizer: DomSanitizer,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private orientationService: OrientationLockService,
    private deviceInfoService: DeviceInfoService,
    private cdr: ChangeDetectorRef,
    private _location: Location,
    private clientService: ClientsService,
    private sqliteDb: SqliteDbService,
    private nativeUploadService: NativeBgUploadService,
  ) {
    const routeId = this.route.snapshot.paramMap.get('rKey');

    if (routeId) {
      this.routeId = routeId;
      this.getPatrolRouteDetail();
    }
  }

  ngOnDestroy() {
    if (this.deviceInfoSubscription) this.deviceInfoSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.getCheckpointPatrolTypeDetail();
    this.deviceInfoService.isDeviceChrome().then((value: any) => {
      this.nfcReaderAvailable = 'NDEFReader' in window && value;
    });
    this.deviceInfoSubscription =
      this.deviceInfoService.deviceInfoSubject.subscribe((value: any) => {
        if ('appStatus' in value) {
          if (this.offlineMode && value?.appStatus) {
            this.refreshData = true;
          }
          this.offlineMode = !value?.appStatus;
        }
        if ('syncComplete' in value) {
          this.syncInProgress = false;
        }
      });
    this.nativeUploadSubscription =
      this.nativeUploadService.apiResponseSubject.subscribe((value: any) => {
        if (
          this.checkpointPatrolDetailData?.id &&
          value?.history?.patrol_route_id == this.checkpointPatrolDetailData?.id
        ) {
          setTimeout(() => {
            this.formatHistory(value);
          }, 500);
        }
      });

    this.subscriberUserId =
      this.appService.getUserData()?.subscriber?.subscriber_user_id;
    this.isAdmin = this.dataCheckService.isUserAdmin();
    this.isDispatchUser = this.dataCheckService.isDispatchUser({
      permission: 'job_type',
      action: 'edit',
      type_identity: 4,
    });

    navigator?.serviceWorker?.controller?.postMessage(
      {
        type: 'INIT_PATROL_DETAIL_PORT',
      },
      [this.messageChannel.port2],
    );
    // // Listen to the response
    this.messageChannel.port1.onmessage = (event) => {
      if (event?.data?.data) {
        this.ngZone.run(() => {
          setTimeout(() => {
            this.checkpointPatrolDetailData = event?.data?.data;
            setTimeout(() => {
              this.formatHistory(event?.data);
            }, 500);
          }, 100);
        });
      }

      if (
        event?.data?.history?.patrol_route_id ==
        this.checkpointPatrolDetailData?.id
      ) {
        setTimeout(() => {
          this.formatHistory(event?.data);
        }, 500);
      } else if (event?.data?.status === 'failure') {
        this.formatCachedListWithTimeOut();
      }
    };
  }

  getCheckpointPatrolTypeDetail() {
    this.jobService.getJobParams().subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.patrolJobTypeData = response?.data?.find(
          (item: any) => item?.type_identity === 4,
        );
      }
    });
  }

  formatDateWithoutTime = (date: any) => {
    date.setHours(0, 0, 0, 0);
    return date.getTime();
  };
  getTimeDifference() {
    let [startTime, endTime] = getStartEndDateTime(
      this.checkpointPatrolDetailData?.roster_scheduler,
      this.checkpointPatrolDetailData?.schedule_event_date,
    );
    let startTimeCopy = new Date(startTime.getTime());
    let endTimeCopy = new Date(endTime.getTime());
    this.scheduleDuration = this.getTimeDiff(startTimeCopy, endTimeCopy);

    this.patrolTime = { startTime: startTime, endTime: endTime };

    this.scheduleCheckFn(startTimeCopy, endTimeCopy);
  }

  pad(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }
  getTimeDiff(startTime: any, endTime: any) {
    const maxStartTime = Math.max(startTime?.getTime(), new Date().getTime());

    const diffValue = endTime?.getTime() - maxStartTime;

    var minuteDifference = diffValue / (1000 * 60);

    [this.intervalData, this.welfareReminderDict] =
      getWelfareCheckInterval(minuteDifference);

    let diffInTime = endTime?.getTime() - startTime?.getTime();

    if (!diffInTime) return '00:00';

    let seconds = Math.floor(diffInTime / 1000);

    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);

    return `${this.pad(hours)}:${this.pad(minutes)}`;
  }
  setTime(date: Date, time: string) {
    const [hours, minutes] = time?.split(':');
    date.setHours(parseInt(hours));
    date.setMinutes(parseInt(minutes));
  }
  isPastScheduleCheck() {
    // https://app.shortcut.com/sendem/story/9942/fb-moo2505283904-rostered-shifts#activity-9977
    const endDateTime = new Date(
      (this.checkpointPatrolDetailData?.schedule_event_date ||
        this.checkpointPatrolDetailData.roster_scheduler.end_day) +
        ' ' +
        this.checkpointPatrolDetailData.roster_scheduler.end_time,
    );
    if (
      this.checkpointPatrolDetailData.roster_scheduler?.start_time >
        this.checkpointPatrolDetailData.roster_scheduler?.end_time &&
      this.checkpointPatrolDetailData?.roster_scheduler?.repeat_type != 'once'
    ) {
      endDateTime.setDate(endDateTime.getDate() + 1);
    }

    endDateTime.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.isCurrentORFutureSchedule = endDateTime.getTime() >= today.getTime();
  }
  sheduleIfChecks() {
    const now = new Date();
    this.isPastScheduleCheck();

    const startTime = new Date(
      this.checkpointPatrolDetailData.roster_scheduler.start_day +
        ' ' +
        this.checkpointPatrolDetailData.roster_scheduler.start_time,
    );
    const endTime = new Date(
      this.checkpointPatrolDetailData.roster_scheduler.end_day +
        ' ' +
        this.checkpointPatrolDetailData.roster_scheduler.end_time,
    );

    const canUpdateSchedule =
      endTime.getTime() > now.getTime() &&
      (!this.checkpointPatrolDetailData?.schedule_event_date ||
        this.formatDateWithoutTime(
          new Date(this.checkpointPatrolDetailData?.schedule_event_date),
        ) >= this.formatDateWithoutTime(now));

    if (!(this.isAdmin || this.isDispatchUser)) {
      this.canScheduleBeUpdated = false;
      this.showWelfareItem = canUpdateSchedule;

      return;
    }

    this.canScheduleBeUpdated = canUpdateSchedule;

    this.showWelfareItem = this.canScheduleBeUpdated;

    this.hasScheduleStarted = startTime.getTime() < new Date().getTime();
  }
  scheduleCheckFn(startDatetime: any, endDateTime: any) {
    const isAdminORDispatcher = this.isAdmin || this.isDispatchUser;
    const subscriberSettings =
      this.dataCheckService.getSubscriberSettings() || {};

    if (this.checkpointPatrolDetailData?.subscriber_users?.length) {
      const jobAssignee =
        this.checkpointPatrolDetailData?.subscriber_users?.[0];
      this.requiresAcceptance =
        jobAssignee?.id === this.subscriberUserId &&
        jobAssignee?.acceptance_status == 2 &&
        this.patrolJobTypeData?.requires_acceptance;
      if (jobAssignee?.id === this.subscriberUserId) {
        let requiresClockInOut = this.dataCheckService.requireClockInOut();
        requiresClockInOut = this.checkpointPatrolDetailData
          ?.user_current_clock_status_for_shift
          ? requiresClockInOut
          : false;
        if (requiresClockInOut) {
          this.shiftClockInOutParms.hasUserClockedIn =
            !!this.checkpointPatrolDetailData
              ?.user_current_clock_status_for_shift?.[0];

          this.shiftClockInOutParms.hasUserClockedOut =
            !!this.checkpointPatrolDetailData
              ?.user_current_clock_status_for_shift?.[1];
        }

        this.shiftClockInOutParms = {
          ...this.shiftClockInOutParms,
          requiresClockInOut: requiresClockInOut,
          shiftStartTime: new Date(startDatetime),
          shiftEndTime: new Date(endDateTime),
          cPatrolId: this.checkpointPatrolDetailData?.id,
        };
      }
    }
    const today = this.formatDateWithoutTime(new Date());

    this.scheduleCheck =
      this.formatDateWithoutTime(startDatetime) <= today &&
      this.formatDateWithoutTime(endDateTime) >= today;

    const shiftAutoAccept = subscriberSettings?.shift_auto_accept || false;
    this.canDeclineJob =
      !isAdminORDispatcher &&
      new Date().getTime() + 3600000 * 24 < new Date(startDatetime).getTime() &&
      !shiftAutoAccept;
    // guards can Decline Shift if its after 24 hrs https://app.shortcut.com/sendem/story/5680/guards-can-decline-shifts
    // https://app.shortcut.com/sendem/story/11404/override-shift-acceptance-feat
  }

  getDetailFromServer() {
    this.rsService
      .getPatrolRoute({
        patrol_route_id: this.routeId,
      })
      .subscribe((response: any) => {
        // this.formatData(response);
        if (response?.status === 'success') {
          this.checkpointPatrolDetailData = response?.data;

          this.formatHistory(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }

        this.spinnerService.hide();
      });
  }

  getPatrolRouteDetail() {
    setTimeout(() => {
      this.pageService.miscSubjectParam.next({
        isOnEvent: true,
      });
    }, 100);
    this.spinnerService.show('Fetching Data');
    this.getJobDetailsFromClient(this.routeId);
    this.getDetailFromServer();
  }
  async getJobDetailsFromClient(id: string) {
    let result: any;
    // if (this.isNativeApp) {
    //   try {
    //     result = await this.sqliteDb.getCachedItemRow('job', id);
    //   } catch (error) {
    //     throw error;
    //   }
    // } else {
    result = await gTDB.cachedData
      .where('shortPath')
      .equals(`c_patrol_${id}`)
      .first();

    this.checkpointPatrolDetailData = result?.patrolDetailData?.data;
    this.formatHistory(result?.patrolDetailData);
    this.fetchingDataFromServer = true;
  }

  formatExistingData() {
    const isAdminORDispatcher =
      this.isAdmin || this.dataCheckService.isDispatchUser();
    if (!isAdminORDispatcher) {
      // if not part of assignees route to home page
      const isUserInAssignees =
        this.checkpointPatrolDetailData?.subscriber_users?.some(
          (assignee: any) => assignee?.id === this.subscriberUserId,
        );
      if (!isUserInAssignees) {
        this.router.navigate([`/`]);
      }
    }
    this.selectedEvent = null;

    this.spinnerService.hide();
    this.dialogRef?.close();

    this.selectedCheckpoints = JSON.parse(
      JSON.stringify(this.checkpointPatrolDetailData?.check_points),
    );
    this.nfcCheckpointsInPatrol =
      this.checkpointPatrolDetailData?.check_points?.some(
        (cp: any) => cp?.is_nfc_code && cp?.qr_code,
      );
    this.selectedAssignee =
      this.checkpointPatrolDetailData?.subscriber_users?.[0];

    this.filterPatrolData = { checkpoint: [], company: [], site: [] };
    this.hasQrCheckpoint = false;
    this.checkpointPatrolDetailData?.check_points?.forEach(
      (checkpoint: any) => {
        if (!this.filterPatrolData.checkpoint.includes(checkpoint?.id)) {
          this.filterPatrolData.checkpoint.push(checkpoint?.id);
        }
        if (checkpoint?.site_id) {
          if (!this.filterPatrolData.site.includes(checkpoint?.site_id)) {
            this.filterPatrolData.site.push(checkpoint?.site_id);
          }
        } else {
          if (!this.filterPatrolData.company.includes(checkpoint?.company_id)) {
            this.filterPatrolData.company.push(checkpoint?.company_id);
          }
        }

        if (checkpoint?.qr_code) this.hasQrCheckpoint = true;
      },
    );
    let startDay = this.checkpointPatrolDetailData?.schedule_event_date
      ? new Date(this.checkpointPatrolDetailData?.schedule_event_date)
      : this.checkpointPatrolDetailData?.roster_scheduler?.start_day
        ? new Date(this.checkpointPatrolDetailData?.roster_scheduler?.start_day)
        : new Date();
    startDay.setDate(startDay.getDate() - 1);

    this.getTimeDifference();
    this.sheduleIfChecks();
    this.schedulerForm.patchValue(
      this.checkpointPatrolDetailData?.roster_scheduler,
    );

    this.selectedInterval = this.checkpointPatrolDetailData?.interval_check
      ? this.checkpointPatrolDetailData?.interval_check
      : this.intervalData[0]?.value;
    this.findScannedCheckpoints();
    this.updateBtnPressed = false;
  }

  openTemplate(template: TemplateRef<any>, updateItem: string) {
    this.patrolRouteCPList = [];
    this.assigneeList = [];
    if (updateItem === 'checkpoint') {
      this.selectedCheckpoints = JSON.parse(
        JSON.stringify(this.checkpointPatrolDetailData?.check_points),
      );
      this.cpSiteFilter = {};
      this.patrolCpFilterValue = '';
      this.onSiteSearch();
      this.getCheckpointsCount();
      this.getPatrolRouteCheckpoints();
    } else if (updateItem === 'assignee') {
      this.getAssignees();
      this.selectedAssignee =
        this.checkpointPatrolDetailData?.subscriber_users?.[0];
    } else if (updateItem === 'name') {
      this.newPatrolName = this.checkpointPatrolDetailData?.name;
    }
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  openAssigneeDetail(assignee: any) {
    if (assignee.id) {
      this.dialogService.open(AddEditUserComponent, {
        data: {
          editUser: true,
          detailData: assignee,
        },
      });
    }
  }
  getCheckpointsCount() {
    let params: any = { get_count: 1 };

    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.patrolRouteCpTotalCount = response?.cp_count;
        }
      });
  }

  getPatrolRouteCheckpoints(loadMore = false) {
    let params: any = { rows: 10, cursor_based_pagination: 1 };

    if (this.patrolCpFilterValue?.length > 2) {
      params['search_str'] = this.patrolCpFilterValue;
    }
    if (this.patrolCPCursor) {
      params['next_cursor'] = this.patrolCPCursor;
    }
    if (this.cpSiteFilter?.id) params['site_id'] = this.cpSiteFilter?.id;
    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.patrolCPCursor = response?.next_cursor;
          if (loadMore) {
            this.patrolRouteCPList.push(...response['data']);
            const seen = new Set();

            this.patrolRouteCPList = this.patrolRouteCPList?.filter(
              (item: any) => {
                if (seen.has(item?.id)) return false;
                seen.add(item?.id);
                return true;
              },
            );
          } else {
            this.patrolRouteCPList = response['data'];
          }

          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  onLoadMore() {
    this.getPatrolRouteCheckpoints(true);
  }
  removeSelectedCP(selectedIndex: number) {
    this.lastAddedCheckpointID = '';
    this.selectedCheckpoints = this.selectedCheckpoints?.filter(
      (checkpoint: any, index: number) => index !== selectedIndex,
    );
  }

  addSelectedCP(addCheckpoint: any) {
    this.lastAddedCheckpointID = '';

    if (this.selectedCheckpoints?.length < 250) {
      this.selectedCheckpoints.push(addCheckpoint);

      setTimeout(() => {
        this.lastAddedCheckpointID = addCheckpoint?.id;
        const lastElement: any = document.getElementById('lastElementAnchor');
        if (lastElement) {
          lastElement.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }
      }, 50);
      if (this.checkpointAddedTimeoutFn)
        clearTimeout(this.checkpointAddedTimeoutFn);
      this.checkpointAddedTimeoutFn = setTimeout(() => {
        this.lastAddedCheckpointID = '';
      }, 1500);
    }
  }
  addAllCheckpoints() {
    this.patrolRouteCPList?.forEach((checkpoint: any) =>
      this.addSelectedCP(checkpoint),
    );
  }
  searchCheckPoints(event?: any) {
    this.patrolCpFilterValue = event.target.value;
    if (event.target.value?.length > 1) {
      if (this.checkpointSearchTimeoutFn)
        clearTimeout(this.checkpointSearchTimeoutFn);
      this.checkpointSearchTimeoutFn = setTimeout(() => {
        this.getFreshCheckpoints();
      }, 750);
    } else if (!event.target.value?.length) {
      this.patrolRouteCPList = [];
      this.getFreshCheckpoints();
    }
  }
  onSelectSite(siteData: any) {
    if (siteData?.id !== this.cpSiteFilter?.id) {
      this.cpSiteFilter = siteData;
      this.getFreshCheckpoints();
    }
  }
  getFreshCheckpoints() {
    this.patrolCPCursor = '';

    this.getPatrolRouteCheckpoints();
  }

  checkpointUpdateDisabling(): boolean {
    if (!this.selectedCheckpoints?.length) {
      return true;
    }
    if (
      this.selectedCheckpoints?.length ===
        this.checkpointPatrolDetailData?.check_points?.length &&
      this.selectedCheckpoints?.every(
        (obj1: any, index: number) =>
          this.checkpointPatrolDetailData?.check_points?.[index]?.id ===
          obj1?.id,
      )
    ) {
      return true;
    }

    return false;
  }

  updatePatrolRoute(updateType: string) {
    this.spinnerService.show();
    this.updateBtnPressed = true;
    let updateData: any = { patrol_route_id: this.routeId };
    let reqParams: any = {};

    switch (updateType) {
      case 'checkpoint':
        updateData.checkpoints = [
          ...this.selectedCheckpoints?.map((checkpoint: any) => ({
            id: checkpoint?.id,
          })),
        ];
        reqParams.update_checkpoints = 1;
        break;

      case 'assignee':
        let assignee_ids = [];
        if (this.selectedAssignee?.id)
          assignee_ids.push(this.selectedAssignee?.id);
        updateData.assignees = assignee_ids;
        reqParams.update_assignees = 1;
        break;

      case 'name':
        updateData.name = this.newPatrolName;
        reqParams.update_name = 1;
        break;
      case 'welfare_interval':
        updateData.interval_check = this.selectedInterval;
        reqParams.update_interval_check = 1;
        break;
      case 'patrol_brief':
        updateData.patrol_brief = this.newInfromation;
        reqParams.update_patrol_brief = 1;
        break;
      case 'generate_missed_report':
        reqParams.generate_missed_report = 1;
        break;

      case 'decline_job':
        reqParams.decline_job = 1;
        updateData.decline_reason = this.declineReason;
        break;
      case 'acceptJob':
        reqParams.accept_job = 1;
    }

    this.rsService
      .managePatrolRoute(updateData, reqParams)
      .then((response: any) => {
        if (response?.status === 'success') {
          this.checkpointPatrolDetailData = response?.data;

          const isDispatcherAdmin = this.isAdmin || this.isDispatchUser;
          const isJobDeclined =
            !isDispatcherAdmin &&
            reqParams?.decline_job &&
            updateData?.decline_reason &&
            !this.checkpointPatrolDetailData?.subscriber_users?.some(
              (user: any) => user?.id == this.subscriberUserId,
            );
          if (!response?.data?.id || isJobDeclined) {
            this._location.back();
            return;
          }

          this.formatHistory(response);

          this.toasterService.setMessage({
            successMessage: response?.message,
            errorMessage: '',
          });
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
          this.updateBtnPressed = false;
        }

        this.spinnerService.hide();
      });
  }
  shiftClick(elementID: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementID);
      element?.click();
      element?.focus();
    }, 100);
  }

  startEndTimeComparison() {
    let startTime = new Date(
      this.schedulerForm.value.start_day +
        ' ' +
        this.schedulerForm.value.start_time,
    );
    let endTime = new Date(
      this.schedulerForm.value.start_day +
        ' ' +
        this.schedulerForm.value.end_time,
    );

    return startTime.getTime() > endTime.getTime();
  }

  openScheduleTemplate() {
    if (!(this.isAdmin || this.isDispatchUser)) return;
    if (!this.checkpointPatrolDetailData?.roster_scheduler?.id) return;

    const dialogRef = this.dialogService.open(ChangeScheduleComponent, {
      data: {
        roster_scheduler: this.checkpointPatrolDetailData?.roster_scheduler,
        schedule_event_date:
          this.checkpointPatrolDetailData?.schedule_event_date,
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.schedulerForm.patchValue(res);
        this.updateSchedule();
      }
    });
  }
  changeShiftDateTime(dateTimeType: number, event: any) {
    let startDateTimeValid = true;
    if (dateTimeType === 0) {
      this.schedulerForm.controls['start_day'].setValue(
        getFormattedDate(event.target.value),
      );
      const selectedDate = new Date(event.target.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        this.schedulerForm.controls['start_day'].setErrors({
          invalidStartDate: true,
        });
        startDateTimeValid = false;
      } else {
        this.schedulerForm.controls['start_day'].setErrors(null);
      }
      this.schedulerForm.controls['start_time'].setValue(
        getFormattedTime(event.target.value),
      );
      const scheduleEndDateTime = new Date(
        this.schedulerForm.value.end_day +
          ' ' +
          this.schedulerForm.value.end_time,
      );

      if (
        scheduleEndDateTime.getTime() < new Date(event.target.value).getTime()
      ) {
        const newEndDate = new Date(event.target.value);
        newEndDate.setHours(newEndDate.getHours() + 8);

        this.schedulerForm.controls['end_day'].setValue(
          getFormattedDate(newEndDate),
        );
        this.schedulerForm.controls['end_time'].setValue(
          getFormattedTime(newEndDate),
        );
        this.endDateTime = getFormattedDateTime(newEndDate);
      }
    } else {
      this.schedulerForm.controls['end_day'].setValue(
        getFormattedDate(event.target.value),
      );

      if (
        new Date(getFormattedDate(event.target.value)) <
        new Date(this.schedulerForm.value.start_day)
      ) {
        this.schedulerForm.controls['end_day'].setErrors({
          invalidStartDate: true,
        });
        startDateTimeValid = false;
      } else {
        this.schedulerForm.controls['end_day'].setErrors(null);
      }
      this.schedulerForm.controls['end_time'].setValue(
        getFormattedTime(event.target.value),
      );
    }
    this.shiftTimeExceeded =
      new Date(this.endDateTime)?.getTime() -
        new Date(this.startDateTime)?.getTime() >
      MAX_SHIFT_DURATION * 60 * 60 * 1000;
    this.disableShiftUpdate =
      (new Date(this.originalDateTimeShift?.startDateTime)?.getTime() ==
        new Date(this.startDateTime)?.getTime() &&
        new Date(this.originalDateTimeShift?.endDateTime)?.getTime() ==
          new Date(this.endDateTime)?.getTime()) ||
      !startDateTimeValid ||
      new Date(this.startDateTime)?.getTime() ===
        new Date(this.endDateTime)?.getTime() ||
      this.shiftTimeExceeded;
  }
  formatScheduleForm(form: any) {
    form.value.start_day =
      form.value.start_day == ''
        ? ''
        : formatDate(form.value.start_day, 'yyyy-MM-dd', 'en');
    form.value.end_day =
      form.value.end_day == null
        ? null
        : formatDate(form.value.end_day, 'yyyy-MM-dd', 'en');
    let timezoneOffset = new Date();
    return {
      time_offset: timezoneOffset.getTimezoneOffset(),
      ...form.value,
    };
  }

  updateSchedule() {
    this.spinnerService.show();

    let data: any = {
      patrol_route_id: this.checkpointPatrolDetailData?.id,
      time_offset: new Date().getTimezoneOffset(),
      ...this.formatScheduleForm(this.schedulerForm),
    };

    this.rsService
      .updateRosterShifts(this.checkpointPatrolDetailData?.id, data, {
        update_individual_shift: 1,
        patrol_job: 1,
      })
      .then((response: any) => {
        // this.formatData(response);
        if (response?.status === 'success') {
          this.getPatrolRouteDetail();
          this.toasterService.setMessage({
            successMessage: 'Shift Updated',
            errorMessage: '',
          });
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }

        this.spinnerService.hide();
      });
  }
  openIntervalCheckTemplate(template: TemplateRef<any>) {
    this.dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
  }
  updateInterval(interval: Number) {
    this.selectedInterval = interval;
    this.updatePatrolRoute('welfare_interval');
  }
  async closeDetailedHome() {
    if (
      [
        'scanCheckPoint',
        'addSiteComment',
        'addSitePhoto',
        'updateJob',
      ].includes(this.updateTask)
    ) {
      this.updateTask = null;
    }
    const swUpdate: any = this.appService.getSWUpdate();

    if (!swUpdate?.isEnabled || this.offlineMode) {
      this.getPatrolUpdates();
    }
    this.formatCachedListWithTimeOut();
  }
  formatClientSideCachedItem(cachedItem: any, historyMap: any) {
    if (
      !cachedItem ||
      cachedItem?.patrol_route_id !== this.checkpointPatrolDetailData?.id
    )
      return;

    const cachedItemTimestamp = (cachedItem?.updated_at || 0) * 1000;

    //  Existing History Item Updates
    if (cachedItem?.id) {
      if (
        cachedItem?.edit_comment ||
        cachedItem?.delete_update ||
        cachedItem?.restore_update
      ) {
        const update = historyMap.get(Number(cachedItem?.id));

        if (update) {
          update.cachedData = true;
        }
      }
      return;
    }

    // Remaining Data List Additions
    const lookupKey = `${cachedItem?.indexDBId}|${cachedItemTimestamp}`;

    if (!this.loggedInUpdatesSet.has(lookupKey)) {
      this.loggedInUpdatesSet.add(lookupKey);
      const data = this.formatCachedData(cachedItem);

      this.patrolUpdateLog.push(data);
    }
  }
  async formatCachedList() {
    const apiResponseDict: any =
      (await gTDB.userData.get('apiResponseDict')) || {};

    this.itemsNotInServer = [];
    this.errorItemsIdsInQueue.clear();

    const itemsNotInServerIds = new Set();
    const loggedInUsersUpdates = this.patrolUpdateLog?.filter(
      (item: any) =>
        item?.subs_user_id == this.subscriberUserId &&
        [0, 1, 2, 6, 7].includes(item?.event_action),
    );
    let nativeDbDataList: any = [];
    if (this.isNativeApp) {
      try {
        nativeDbDataList = [
          ...(await this.sqliteDb.getSavedUpdateRow(
            'patrol',
            this.checkpointPatrolDetailData?.id,
          )),
          ...(await this.sqliteDb.getSavedUpdateRow(
            'scan_checkpoint',
            this.checkpointPatrolDetailData?.id,
          )),
        ];
      } catch (error) {
        throw error;
      }
    }
    const indexedDbListData: any = await this.getAllIndexedDbItems();

    const historyMap = new Map<any, any>();

    this.patrolUpdateLog?.check_list_tasks?.forEach((task: any) => {
      if (task?.id) historyMap.set(task.id, task);
    });

    loggedInUsersUpdates?.forEach((item: any) => {
      if (item?.index_db_id && item?.recorded_at) {
        const timestamp = new Date(item.recorded_at).getTime();

        this.loggedInUpdatesSet.add(`${item.index_db_id}|${timestamp}`);
      }
    });

    indexedDbListData.forEach((cachedItem: any) => {
      this.formatClientSideCachedItem(cachedItem, historyMap);

      const failedItem =
        apiResponseDict?.[cachedItem?.indexDBId]?.errorMessages?.length;
      if (failedItem) {
        // had an error

        cachedItem.errorMessages =
          apiResponseDict?.[cachedItem?.indexDBId]?.errorMessages;
        if (!itemsNotInServerIds.has(cachedItem?.indexDBId)) {
          itemsNotInServerIds.add(cachedItem?.indexDBId);
          this.itemsNotInServer.push(cachedItem);
        }
        this.errorItemsIdsInQueue.add(cachedItem?.indexDBId);
      }
      const notInServerYet = cachedItem?.cachedData || !cachedItem?.id;
      if (notInServerYet && !itemsNotInServerIds.has(cachedItem?.indexDBId)) {
        itemsNotInServerIds.add(cachedItem?.indexDBId);
        this.itemsNotInServer.push(cachedItem);
      }
    });
    for (const data of nativeDbDataList) {
      const requestData = JSON.parse(data?.data) || {};
      const cachedItem = requestData?.body || {};
      cachedItem.indexDBId = data?.id;
      cachedItem.updated_at = new Date(data?.updatedAt).getTime() / 1000;
      cachedItem.job_id = data?.eventId;
      cachedItem.isInNativeDb = true;
      cachedItem.pathName =
        this.pageService.getPathNameForSavedUpdatesInNativeDb(data?.type);
      if (requestData?.uploadedFilePath) {
        cachedItem.file = await this.appService.getDisplayUrlForFileInDevice(
          requestData.uploadedFilePath,
        );
      }

      this.formatClientSideCachedItem(cachedItem, historyMap);
      if (data?.status == 4 && data?.retryResponse) {
        // had an error
        const errorMessages = JSON.parse(data?.retryResponse);
        const lastError = errorMessages[errorMessages?.length - 1].split(':');
        if (lastError?.[1]) {
          cachedItem.errorMessages = [lastError?.[1]];
          if (!itemsNotInServerIds.has(cachedItem?.indexDBId)) {
            itemsNotInServerIds.add(cachedItem?.indexDBId);
            this.itemsNotInServer.push(cachedItem);
          }
          this.errorItemsIdsInQueue.add(cachedItem?.indexDBId);
        }
      }
      const notInServerYet = cachedItem?.cachedData || !cachedItem?.id;
      if (notInServerYet && !itemsNotInServerIds.has(cachedItem?.indexDBId)) {
        itemsNotInServerIds.add(cachedItem?.indexDBId);
        this.itemsNotInServer.push(cachedItem);
      }
    }

    this.patrolUpdateLog = this.patrolUpdateLog?.sort(
      (a: any, b: any) =>
        new Date(a?.updated_at).getTime() - new Date(b?.updated_at).getTime(),
    );
    const patrolLogUpdates = this.patrolUpdateLog?.filter(
      (history: any) =>
        !history.source ||
        (history?.source == 'history' &&
          [10, 11, 12, 13].includes(history?.event_action)),
    );
    this.mobileUpdatesLog = this.patrolUpdateLog?.filter(
      (history: any) => !history.source,
    );
    this.patrolLogUpdates = [...patrolLogUpdates];
    if (this.selectedEvenId) {
      // in case of delete/restore/edit comments reopen the selected event after the update has been made.
      const updatedEvent = this.patrolLogUpdates?.find(
        (update: any) => update?.id === this.selectedEvenId,
      );
      if (updatedEvent?.id) this.onTableRowClick(updatedEvent);
    }
    this.cdr.detectChanges();
  }

  formatCachedListWithTimeOut() {
    if (this.cachedListWithTimeOut) clearTimeout(this.cachedListWithTimeOut);
    this.cachedListWithTimeOut = setTimeout(() => {
      this.formatCachedList();
    }, 500);
  }
  formatCachedData(item: any) {
    let eventDict: any = {};
    if (item?.pathName?.includes('api/patrol/add_update/')) {
    if (item?.image_source === 'live') {
      eventDict = { event_action: 2, action: 'Uploaded Image' };
    } else if (item?.image_source === 'device') {
      eventDict = { event_action: 7, action: 'File Uploaded' };
    } else {
      eventDict = { event_action: 1, action: 'Added Comment' };
    }
  } else if (item?.pathName?.includes('api/patrol/scan_checkpoint/')) {
    eventDict = item?.qr_text
      ? item?.checkpointDetail?.cp_type == 2
        ? { event_action: 12, action: 'NFC Scan' }
        : { event_action: 6, action: 'QR Scan' }
      : { event_action: 0, action: 'Checkpoint Scan' };
  }

    return {
      cachedData: true,
      file_extension: item?.file_extension,
      detail: item?.comment ?? item?.checkpointDetail?.name ?? null,
      gps: item?.device_info?.gps,
      updated_at: item?.updated_at * 1000,
      recorded_at: item?.updated_at * 1000,
      index_db_id: item?.indexDBId,
      file: item?.file || null,
      subs_user_id: this.subscriberUserId,
      ...eventDict,
      device_details: {
        Ip: item?.device_info?.gps?.ip,
        Browser: `${item?.device_info?.browser} - ${item?.device_info?.browser_version}`,
        Device: `${item?.device_info?.device} - ${item?.device_info?.deviceType} `,
      },
    };
  }

  editComment(commentData: any, requestRef: TemplateRef<any>) {
    this.newComment = commentData?.detail;
    this.previousComment = commentData?.detail;
    this.dialogService.open(
      requestRef,
      {
        data: commentData,
      },
      this.viewContainerRef,
    );
  }
  addComment(data: any) {
    if (!data?.id && !this.newComment?.trim()) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Comment cannot be empty',
      });
      return;
    }

    this.spinnerService.show();
    let body = {
      company_id: data?.company_id,
      comment: this.newComment,
      id: data?.id,
      edit_comment: 1,
      patrol_route_id: this.checkpointPatrolDetailData?.id,
    };
    this.checkpointService.updateClient(body).then((response: any) => {
      this.newComment = '';

      this.formatHistory(response);
    });
  }
  onOpenImage(event: any, data: any) {
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;

    this.dialogRef = this.dialogService.open(MediaPreviewComponent, {
      data: { mediaSrc: srcAttr.nodeValue, timeStamp: data.updated_at },
    });
  }
  getPatrolUpdates() {
    this.rsService
      .managePatrolRoute(
        {
          patrol_route_id: this.routeId,
        },
        { history: 1 },
      )
      .then((response: any) => {
        // this.formatData(response);
        if (response?.status === 'success') {
          this.formatHistory(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }

        this.spinnerService.hide();
      });
  }
  async deleteItemFromNativeDb(update: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    const dRes = await firstValueFrom(dialogRef.afterClosed());
    if (dRes === true) {
      const pkId = update?.index_db_id;

      if (update?.isInNativeDb) {
        try {
          await this.sqliteDb.deleteSavedUpdateRow('patrol', pkId);
        } catch (error) {
          throw error;
        }
      } else {
        gTDB.gtSavedData
          .where({
            indexDBId: pkId,
          })
          .delete();
      }
      this.patrolUpdateLog = JSON.parse(
        JSON.stringify(this.patrolUpdateLogBackup),
      );
      this.loggedInUpdatesSet.clear();

      setTimeout(() => {
        this.getPatrolUpdates();
      }, 50);
    }
  }
  async formatHistory(response: any) {
    this.shiftClockInOutParms.hasUserClockedIn =
      this.checkpointPatrolDetailData?.has_user_clocked_into_shift;
    if (response?.history) {
      // this.patrolLogUpdates = [];
      this.patrolUpdateLog = JSON.parse(
        JSON.stringify(response?.history?.data),
      );
      this.loggedInUpdatesSet.clear();

      this.patrolUpdateLogBackup = JSON.parse(
        JSON.stringify(response?.history?.data),
      );

      this.missedCheckpoints = response?.history?.missed_checkpoints;
      this.patrolRouteStatusKey = this.scanComplete
        ? 1
        : response?.history?.patrol_route_status;
    }
    this.formatCachedListWithTimeOut();
    this.findScannedCheckpoints();
    this.formatExistingData();
    this.fetchingDataFromServer = false;
    this.updateJobDetailsToClient(response);
  }
  async updateJobDetailsToClient(response: any) {
    if (!response?.data?.id) return;
    const shortPath = `c_patrol_${this.routeId}`;
    const jobData = {
      patrolDetailData: response,
      shortPath: shortPath,
      updatedAt: new Date().getTime(),
    };
    await gTDB.cachedData.put(jobData, shortPath);
  }

  findScannedCheckpoints() {
    let alreadyScannedCheckpoint: any = this.patrolLogUpdates
      ?.filter(
        (update: any) =>
          [0, 6, 12].includes(update?.event_action) &&
          !update?.cachedData &&
          this.patrolTime.startTime.getTime() <=
            new Date(update?.updated_at).getTime() &&
          new Date(update?.updated_at).getTime() <=
            this.patrolTime.endTime.getTime(),
      )
      ?.map((update: any) => update?.event_id);

    this.scannedCheckpoints = {};

    alreadyScannedCheckpoint?.forEach((item: any) => {
      if (this.scannedCheckpoints[item]) {
        this.scannedCheckpoints[item]++;
      } else {
        this.scannedCheckpoints[item] = 1;
      }
    });
    this.checkpointPatrolDetailData?.check_points?.forEach(
      (checkpoint: any) => {
        if (
          this.scannedCheckpoints?.[checkpoint?.id] &&
          this.scannedCheckpoints?.[checkpoint?.id] > 0
        ) {
          checkpoint.isScanned = true;
          this.scannedCheckpoints[checkpoint?.id] =
            this.scannedCheckpoints[checkpoint?.id] - 1;
        }
      },
    );

    this.scanComplete = this.checkpointPatrolDetailData?.check_points?.every(
      (checkpoint: any) => checkpoint?.isScanned,
    );
    this.scannedCheckpointCount =
      this.checkpointPatrolDetailData?.check_points?.filter(
        (checkpoint: any) => checkpoint?.isScanned,
      )?.length;

    if (!this.sortCheckpointsWithTimeOut) {
      this.sortCheckpointsWithTimeOut = setTimeout(() => {
        this.calculateFixedBottomHeight();

        clearTimeout(this.sortCheckpointsWithTimeOut);
        this.sortCheckpointsWithTimeOut = null;

        // to avoid sorting multiple times as the method is called multiple times due to service worker sync.
        this.checkpointPatrolDetailData?.check_points?.sort(
          (a: any, b: any) => {
            const aScanned = a?.isScanned === true ? 1 : 0;
            const bScanned = b?.isScanned === true ? 1 : 0;
            const aDeleted = a?.is_deleted === true ? 1 : 0;
            const bDeleted = b?.is_deleted === true ? 1 : 0;

            if (aDeleted !== bDeleted) {
              return aDeleted - bDeleted;
            }

            return aScanned - bScanned;
          },
        );
      }, 1000);
    }
  }

  onTableRowClick(eventData: any) {
    this.selectedEvent = eventData;
    this.selectedEvenId = eventData?.id;
  }
  getFileSrc(file: File): SafeUrl {
    let url = URL.createObjectURL(file);
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  onOpenFile(file: any) {
    if (file?.extension === '.pdf') {
      this.downloadFile(file);
    } else {
      this.dialogRef = this.dialogService.open(MediaPreviewComponent, {
        data: { mediaSrc: file?.file_url, timeStamp: file.updated_at },
      });
    }
  }

  downloadFile(file: any) {
    const a = document.createElement('a');
    a.href = file?.file_url;

    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  deleteFile(file: any) {
    let dialogMsg = `Permanently delete file`;
    this.dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Delete File`,
        message: dialogMsg,
      },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();

        this.deletePatrolFile(file);
      }
    });
  }

  deletePatrolFile(file: any) {
    this.spinnerService.show();
    this.rsService
      .managePatrolRoute(
        {
          patrol_route_id: this.routeId,
          file_id: file?.id,
        },
        { remove_patrol_brief: 1 },
      )
      .then((response: any) => {
        // this.formatData(response);
        if (response?.status === 'success') {
          this.checkpointPatrolDetailData = response?.data;

          this.formatHistory(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }

        this.spinnerService.hide();
      });
  }
  handleFileInput(event: any) {
    this.uploadPatrolBrief(event?.target?.files.item(0));
  }
  uploadPatrolBrief(file: any) {
    let params: any = {};
    params['add_patrol_brief'] = 1;
    let formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('patrol_route_id', this.routeId);
    this.spinnerService.show();
    this.appService
      .formDataApi('roster_shift/manage_patrol_route', formData, false, params)
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.checkpointPatrolDetailData = response?.data;

          this.formatHistory(response);
        } else {
          this.toasterService.setMessage({
            errorMessage: response?.message,
            successMessage: '',
          });
        }

        this.spinnerService.hide();
      });
  }
  openPatrolBriefInformationTemplate(template: TemplateRef<any>) {
    this.newInfromation = this.checkpointPatrolDetailData?.patrol_brief;

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }

  dropNewCheckPoint(event: CdkDragDrop<any[]>) {
    moveItemInArray(
      this.selectedCheckpoints,
      event.previousIndex,
      event.currentIndex,
    );
  }

  checkPointCounter(checkpointId: any) {
    return this.selectedCheckpoints?.filter(
      (item: any) => item?.id === checkpointId,
    )?.length;
  }
  removeCheckpointFromSelection(checkpointId: any) {
    let lastIndex = this.selectedCheckpoints
      ?.map((item: any) => item?.id)
      .lastIndexOf(checkpointId);

    if (lastIndex != -1) {
      this.selectedCheckpoints?.splice(lastIndex, 1);
    }
  }
  async getAllIndexedDbItems() {
    try {
      const data = await gTDB.gtSavedData.toArray();

      return data;
    } catch (error) {
      return [];
    }
  }

  generateMissedReport() {
    this.dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Missed Scans Report`,
        message: `Click confirm for a copy of the missed scans report for this patrol.`,
      },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();

        this.updatePatrolRoute('generate_missed_report');
      }
    });
  }
  clearAndFocusTextBox(elementId: string) {
    this.newComment = '';

    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  declineJob() {
    this.updatePatrolRoute('decline_job');
  }
  openJobDeclineTemplate(template: any) {
    this.declineReason = '';
    this.dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
  }
  calculateFixedBottomHeight() {
    // Get the bottom-section-fixed element by ID

    const bottomSectionFixed = document.getElementById('bottom-section-fixed');

    if (bottomSectionFixed) {
      this.bottomSectionFixedHeight =
        bottomSectionFixed.offsetHeight.toString() + 'px';
    }
    setTimeout(() => {
      // added this becuase review status is taking some time to load
      const bottomSectionFixed = document.getElementById(
        'bottom-section-fixed',
      );

      if (bottomSectionFixed) {
        this.bottomSectionFixedHeight =
          bottomSectionFixed.offsetHeight.toString() + 'px';
      }
    }, 1000);
  }
  showOfflineMessage() {
    this.toasterService.setMessage({
      successMessage: '',
      errorMessage: 'Feature not available while offline',
    });
  }
  deleteRestoreUserUpdate(event: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: event?.type === 'delete' ? 'Delete Event' : 'Restore Event',
        message:
          event?.type === 'delete'
            ? `Are you sure you want to delete this event?`
            : 'Are you sure you want to restore this event?',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        let body: any = {
          id: event?.event?.id,
          patrol_route_id: this.checkpointPatrolDetailData?.id,
        };
        body[event?.type === 'delete' ? 'delete_update' : 'restore_update'] = 1;
        this.checkpointService.updateClient(body).then((response: any) => {
          if (response?.status == 'success') {
            this.formatHistory(response);
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: response?.message,
              errorMessage: '',
            });
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response?.message,
            });
          }
        });
      }
    });
  }
  async retryUpdate(indexDbId: any) {
    const apiResponseDict: any =
      (await gTDB.userData.get('apiResponseDict')) || {};
    delete apiResponseDict[indexDbId];
    await gTDB.userData.put(apiResponseDict, 'apiResponseDict');

    this.syncData();
    setTimeout(() => {
      this.getPatrolUpdates();
    }, 50);

    setTimeout(() => {
      this.formatCachedListWithTimeOut();
    }, 500);
    setTimeout(() => {
      this.appService.removeToolTips();
    }, 2000);
  }
  syncData() {
    this.pageService.miscSubjectParam.next({ syncData: true });
    this.syncInProgress = true;
  }
  retrySendingUpdate() {
    if (this.offlineMode) {
      this.showOfflineMessage();
    } else {
      this.syncData();
      this.getPatrolUpdates();
    }
    setTimeout(() => {
      this.appService.removeToolTips();
    }, 2000);
  }
  requireSafetyCheck() {
    if (this.shiftClockInOutParms?.hasUserClockedIn) return [];
    const completedPrompts = new Set(
      this.patrolUpdateLogBackup?.flatMap((item: any) =>
        item?.prompts?.map((prompt: any) => prompt?.prompt_data?.id),
      ),
    );

    return (this.checkpointPatrolDetailData?.safety_prompts || [])?.filter(
      (item: any) => !completedPrompts.has(item?.id),
    );
  }
  async openPrompterComponent(promptInfo: any) {
    const dialogRef = this.dialogService.open(PrompterComponent, {
      data: { promptData: promptInfo?.prompts },
    });
    const value = await firstValueFrom(dialogRef.afterClosed());
    if (!value?.length) return false;

    this.spinnerService.show();

    let fileData: FormData = new FormData();

    fileData.append('update_prompt', '1');
    fileData.append('safety_prompt', '1'); // TODO: make this conditional when adding prompts for responses.

    fileData.append('user_prompt_id', promptInfo?.id);
    fileData.append(
      'prompt_data',
      JSON.stringify([
        {
          data: value,
          prompt_data: {
            id: promptInfo?.id,
            name: promptInfo?.note,
          },
        },
      ]),
    );
    fileData.append('patrol_route_id', this.routeId);

    const response: any = await this.appService.formDataApi(
      'roster_shift/manage_patrol_route',
      fileData,
    );

    if (response['status'] == 'success') {
      this.checkpointPatrolDetailData = response?.data;

      this.formatHistory(response);
    } else {
      this.toasterService.setMessage({
        errorMessage: response?.message,
        successMessage: '',
      });
    }

    this.spinnerService.hide();
    return true;
  }

  async onClockInOutUser() {
    const safetyPrompts = this.requireSafetyCheck();

    if (safetyPrompts?.length) {
      const response = await this.openPrompterComponent(safetyPrompts[0]);

      if (!response) return;
    }
    const dialogRef = this.dialogService.open(
      ClockInOutComponent,
      {
        data: {
          shiftClockInOutParms: this.shiftClockInOutParms,
        },
      },
      this.viewContainerRef,
    );
    const dRes = await firstValueFrom(dialogRef.afterClosed());
    if (!dRes) return;
    this.shiftClockInOutParms.hasUserClockedIn =
      !!dRes?.user_current_clock_status_for_shift?.[0];

    this.shiftClockInOutParms.hasUserClockedOut =
      !!dRes?.user_current_clock_status_for_shift?.[1];
    this.shiftClockInOutParms = {
      ...this.shiftClockInOutParms,
    };
    this.getDetailFromServer();
  }

  inputFieldFocused() {
    this.siteListData = JSON.parse(
      JSON.stringify(this.siteListDataBackup || []),
    );
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteListData = res?.data?.splice(0, 10);
          if (!event) {
            this.siteListDataBackup = JSON.parse(
              JSON.stringify(this.siteListData),
            );
          }
        }
      });
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'end',
      });
    }, 100);
  }
  async openScanCPTemplate() {
    const dialogRef = this.dialogService.open(
      ScanCheckpointComponent,
      {
        data: {
          showNFCScanBtn: this.nfcCheckpointsInPatrol,
          patrolRouteId: this.checkpointPatrolDetailData?.id || '',
        },
      },
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef?.afterClosed());

    if (res?.source == 'scanCheckPoint') {
      this.updateTask = 'scanCheckPoint';
    } else if (res?.source == 'scanQrCode') {
      if (res?.data) {
        if (res?.data?.history) {
          this.formatHistory(res?.data);
        } else {
          this.getPatrolUpdates();
        }
      }
    } else if (res?.source == 'scanNFCCode') {
      if (res?.data) {
        if (res?.data?.history) {
          this.formatHistory(res?.data);
        } else {
          this.getPatrolUpdates();
        }
      }
    }
  }
  onAssigneeSearch(event: any) {
    if (event.target.value?.length > 0) {
      this.getAssignees({ search_str: event?.target?.value });
    } else {
      this.getAssignees();
    }
  }

  getAssignees(params?: any) {
    const reqParams = params || {};

    this.jobService.getUserList(reqParams).subscribe(async (response: any) => {
      if (response['status'] == 'success') {
        setTimeout(() => {
          this.assigneeList = JSON.parse(JSON.stringify(response?.data));
          this.cdr.detectChanges();
        }, 50);
      }
    });
  }
}
